import { Controller } from '@hotwired/stimulus';

export default class PayinController extends Controller {
  static targets = ['amountInput', 'submitButton', 'totalDisplay'];

  static values = {feesRate: Number}

  updateAmount() {
    const value = this.amountInputTarget.value;

    if (value.length === 0) {
      this.submitButtonTarget.disabled = true;
      if (this.hasTotalDisplayTarget) this.totalDisplayTarget.textContent = '';
      return
    }

    const amount = parseFloat(value);
    const feesAmount = amount * (this.feesRateValue / 100);
    const total = (feesAmount + amount).toFixed(2);

    this.submitButtonTarget.disabled = false;
    if (this.hasTotalDisplayTarget) this.totalDisplayTarget.textContent = `${total} €`;
  }
}
